import { BirdviewCard } from '../BirdviewCard'
import { BirdviewTeamMemberRow } from '../BirdviewTeamMemberRow'
import {
  BIRDVIEW_ROW_TARGET,
  BIRDVIEW_SECTION_TARGET,
} from '../DashboardBirdview.constants.targets'
import { useBirdviewListTarget } from '../DashboardBirdview.hooks'

function BirdviewTeamLoadWidget({
  dragHandleProps,
  section,
  title,
  onNavigate,
}) {
  const { getListTarget, getRowListTarget } = useBirdviewListTarget()

  function handleShowAll() {
    onNavigate(getListTarget(BIRDVIEW_SECTION_TARGET.teamLoad))
  }

  function handleOpen(item) {
    onNavigate(
      getRowListTarget({ id: item.id, target: BIRDVIEW_ROW_TARGET.teamLoad })
    )
  }

  return (
    <BirdviewCard
      count={section.total}
      dragHandleProps={dragHandleProps}
      hasMore={section.hasMore}
      isRefreshing={section.isRefreshing}
      skeletonProps={{ hasAction: false, hasSubtitle: false }}
      state={section.state}
      title={title}
      onRetry={section.reload}
      onShowAll={handleShowAll}
    >
      {section.items.map(item => (
        <BirdviewTeamMemberRow item={item} key={item.id} onOpen={handleOpen} />
      ))}
    </BirdviewCard>
  )
}

export default BirdviewTeamLoadWidget
